/**
   *  @class
   *  @function ImageCarousel
   */
  if (!customElements.get('image-carousel')) {
    class ImageCarousel extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const slideshow = this,
          dataset = slideshow.dataset;

        const slideshow_slides = Array.from(slideshow.querySelectorAll('.carousel__slide'));

        // Early return guard — prevents setup when there are no slides
        if (slideshow_slides.length < 1) return;

        const autoplay = Shopify.designMode
            ? false
            : dataset.autoplay == 'false'
            ? false
            : parseInt(dataset.autoplay, 10),
          align = dataset.align == 'center' ? 'center' : 'left',
          prev_buttons = slideshow.querySelectorAll('.flickity-prev'),
          next_buttons = slideshow.querySelectorAll('.flickity-next'),
          rightToLeft = document.dir === 'rtl',
          custom_dots = slideshow.querySelector('.flickity-dots');

        // Cache custom dots li elements once
        const cachedDots = custom_dots ? Array.from(custom_dots.querySelectorAll('li')) : null;

        // ES6 shorthand properties
        const args = {
          wrapAround: true,
          cellAlign: align,
          pageDots: false,
          contain: true,
          fade: false,
          autoPlay: autoplay,
          rightToLeft,
          prevNextButtons: false,
          cellSelector: '.carousel__slide',
          on: {
            ready: function () {
              let flkty = this;
        

              slideshow.updateSlideClasses(flkty);
              // Custom Dots.
              if (cachedDots) {
                cachedDots.forEach((dot, i) => {
                  dot.addEventListener('click', () => flkty.select(i));
                });

                cachedDots[this.selectedIndex].classList.add('is-selected');
              }
            },
            change: function (index) {
              let flkty = this;


              // Custom Dots.
              if (cachedDots) {
                slideshow.updateDots(cachedDots, this.selectedIndex);
              }
              slideshow.updateSlideClasses(flkty);
            },
          },
        };

        // Initiate
        const flkty = new Flickity(slideshow, args);

        this._flkty = flkty;

        dataset.initiated = true;

        // Arrows
        if (prev_buttons) {
          prev_buttons.forEach(function (prev_button) {
            prev_button.addEventListener('click', () => {
              rightToLeft ? flkty.next() : flkty.previous();
            });
            prev_button.addEventListener('keyup', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              rightToLeft ? flkty.next() : flkty.previous();
            });
          });
          next_buttons.forEach(function (next_button) {
            next_button.addEventListener('click', () => {
              rightToLeft ? flkty.previous() : flkty.next();
            });
            next_button.addEventListener('keyup', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              rightToLeft ? flkty.previous() : flkty.next();
            });
          });
        }
      }

      disconnectedCallback() {
        if (this._flkty) {
          this._flkty.destroy();
          this._flkty = null;
        }
      }

      updateDots(dots, selectedIndex) {
        dots.forEach((dot) => dot.classList.remove('is-selected'));
        dots[selectedIndex].classList.add('is-selected');
      }
      updateSlideClasses(flkty) {
        const slides = Array.from(this.querySelectorAll('.carousel__slide'));

        const selected = flkty.selectedIndex;
       const length = slides.length;

        slides.forEach((slide, index) => {
          slide.classList.remove(
            'is-selected',
            'is-side',
            'is-far'
          );

          // 计算距离，支持 wrapAround
          let distance = Math.abs(index - selected);

          if (distance > length / 2) {
            distance = length - distance;
          }

          if (distance === 0) {
            slide.classList.add('is-selected');
          } else if (distance === 1) {
            slide.classList.add('is-side');
          } else if (distance === 2) {
            slide.classList.add('is-far');
          }
        });
      }
    }
    customElements.define('image-carousel', ImageCarousel);
  }